import { SoundWrapper } from './style';
import { SpeakerMute, Speaker2 } from '@styled-icons/fluentui-system-filled'

export default (props) => {
    const { soundOn, clickAction } = props;

    return (
        <SoundWrapper onClick={() => clickAction()}>
            {soundOn ? <Speaker2 width={'35px'} /> : <SpeakerMute width={'35px'} />}
        </SoundWrapper>
    )
}